module.exports = new __parcel__URL__("dragon.4b6d8278.svg").toString();